import RobotService from "../RobotService.js";
import { PaginationStore } from "@/store/pagination-store.js";
import { RobotsResponse } from "@/models/RobotResponse.js";

class RobotsStore extends PaginationStore {
  data() {
    return {
      sizes: [2, 5, 10, 20, 50, 100],
      call: async (pagination) => {
        const param = {
          page: pagination.currentPage,
          size: pagination.elements > 0 ? pagination.elements : 10,
        };
        if (pagination.filters) {
          pagination.filters.baseStationName &&
          pagination.filters.baseStationName != ""
            ? (param["baseStationName"] = pagination.filters.baseStationName)
            : null;
          pagination.filters.reasonSessionTerminated &&
          pagination.filters.baseStationName != ""
            ? (param["reasonSessionTerminated"] =
                pagination.filters.reasonSessionTerminated)
            : null;
        }
        return this.getRobotHistory(param);
      },
    };
  }
  
  async getRobotHistory(param) {
    try {
      const response = await RobotService.getRobotList(param);
      console.log(response);
      let result_1 = new RobotsResponse({});
      if (response.data) {
        result_1 = new RobotsResponse(response.data);
      }
      return await Promise.resolve(result_1);
    } catch (er) {
      console.log(er);
      return await Promise.resolve(new RobotsResponse({}));
    }
  }
}
export const robotsStore = new RobotsStore("ROBOTS");
